var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3521_13350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.7812 2.73438H30.0938V0H27.2812V2.73438H8.71875V0H5.90625V2.73438H4.21875C1.89253 2.73438 0 4.57434 0 6.83594V30.8984C0 33.16 1.89253 35 4.21875 35H31.7812C34.1075 35 36 33.16 36 30.8984V6.83594C36 4.57434 34.1075 2.73438 31.7812 2.73438ZM33.1875 30.8984C33.1875 31.6523 32.5567 32.2656 31.7812 32.2656H4.21875C3.44334 32.2656 2.8125 31.6523 2.8125 30.8984V12.8516H33.1875V30.8984ZM33.1875 10.1172H2.8125V6.83594C2.8125 6.08207 3.44334 5.46875 4.21875 5.46875H5.90625V8.20312H8.71875V5.46875H27.2812V8.20312H30.0938V5.46875H31.7812C32.5567 5.46875 33.1875 6.08207 33.1875 6.83594V10.1172Z",
    fill: "#1996A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.15625 15.7227H5.34375V18.457H8.15625V15.7227Z",
    fill: "#FAB54E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7812 15.7227H10.9688V18.457H13.7812V15.7227Z",
    fill: "#FAB54E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4062 15.7227H16.5938V18.457H19.4062V15.7227Z",
    fill: "#FAB54E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0312 15.7227H22.2188V18.457H25.0312V15.7227Z",
    fill: "#FAB54E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6562 15.7227H27.8438V18.457H30.6562V15.7227Z",
    fill: "#FAB54E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.15625 21.1914H5.34375V23.9258H8.15625V21.1914Z",
    fill: "#FAB54E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7812 21.1914H10.9688V23.9258H13.7812V21.1914Z",
    fill: "#FAB54E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4062 21.1914H16.5938V23.9258H19.4062V21.1914Z",
    fill: "#FAB54E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0312 21.1914H22.2188V23.9258H25.0312V21.1914Z",
    fill: "#FAB54E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.15625 26.6602H5.34375V29.3945H8.15625V26.6602Z",
    fill: "#FAB54E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7812 26.6602H10.9688V29.3945H13.7812V26.6602Z",
    fill: "#FAB54E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4062 26.6602H16.5938V29.3945H19.4062V26.6602Z",
    fill: "#FAB54E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0312 26.6602H22.2188V29.3945H25.0312V26.6602Z",
    fill: "#FAB54E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6562 21.1914H27.8438V23.9258H30.6562V21.1914Z",
    fill: "#FAB54E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3521_13350"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.63946549c10e6ae4e796be43df994eee.svg";
export { ForwardRef as ReactComponent };